import React from 'react';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage, useForm } from '@inertiajs/inertia-react';
import Layout from '@/Shared/Layout';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';

const Create = () => {
    const { organizations } = usePage().props;
    const { data, setData, errors, post, processing } = useForm({
        title: '',
        title_en:'',
        description: '',
        year: '',
        doi: '',
        authors: '',
        journal: '',
        url: '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        post(route('publications.store'));
    }

    return (
        <div>
            <h1 className="mb-8 text-3xl font-bold">
                <InertiaLink
                    href={route('publications')}
                    className="text-indigo-600 hover:text-indigo-700"
                >
                    Publications
                </InertiaLink>
                <span className="font-medium text-indigo-600"> /</span> Create
            </h1>
            <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-wrap p-8 -mb-8 -mr-6">
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Title"
                            name="title"
                            type={"text"}
                            errors={errors.title}
                            value={data.title}
                            onChange={e => setData('title', e.target.value)}
                        />

                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Title EN"

                            type="text"
                            name="title_en"
                            errors={errors.title_en}
                            value={data.title_en}
                            onChange={e => setData('title_en', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Description"
                            name="description"
                            type={"text"}
                            errors={errors.description}
                            value={data.description}
                            onChange={e => setData('description', e.target.value)}
                        />

                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Year"
                            name="year"
                            type="text"
                            errors={errors.year}
                            value={data.year}
                            onChange={e => setData('year', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="URL"
                            name="url"
                            type="text"
                            errors={errors.url}
                            value={data.url}
                            onChange={e => setData('url', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Authors"
                            name="authors"
                            type="text"
                            errors={errors.authors}
                            value={data.authors}
                            onChange={e => setData('authors', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="Journal"
                            name="journal"
                            type="text"
                            errors={errors.journal}
                            value={data.journal}
                            onChange={e => setData('journal', e.target.value)}
                        />
                        <TextInput
                            className="w-full pb-8 pr-6 "
                            label="DOI"
                            name="doi"
                            type="text"
                            errors={errors.doi}
                            value={data.doi}
                            onChange={e => setData('doi', e.target.value)}
                        />

                    </div>
                    <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
                        <LoadingButton
                            loading={processing}
                            type="submit"
                            className="btn-indigo"
                        >
                            Create Publication
                        </LoadingButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

Create.layout = page => <Layout title="Create Publication" children={page} />;

export default Create;
